import React from 'react';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import LevelTag from 'components/vocab/level_tag';
import Text from 'components/text';
import ReactTooltip from 'react-tooltip';
import { observable } from 'mobx';
import { isPresent } from '@seedlang/utils';
import { AppUI } from '@seedlang/state';
import Link from 'components/link';
import VocabListWord from 'components/vocab/vocab_list_word';

const Wrapper = styled.div`
  display: flex;
  gap: 5px;
  margin: ${props => props.margin};
  flex-wrap: wrap;
`;

const RelatedRows = styled.div`
  ${props => !props.isMobile && `
    display: grid;
    grid-template-columns: fit-content(50%) minmax(0, 1fr) 50px;
    column-gap: 24px;
  `}
`;

const LinkedWord = styled.span`
  border-bottom: ${props => props.noBorder ? '' : '2px solid #b5b5b5'};
  cursor: pointer;
`;

const RelatedWordLink = styled(Link)`
  color: inherit;
  display: flex;
  gap: 2px;
  text-decoration: none;
`;

const SeeMore = styled.div`
  background: #ececec;
  border-radius: 5px;
  font-size: 12px;
  padding: 0 5px;
  cursor: pointer;
`;

@observer
class RelatedWords extends React.Component {
  @observable seeMore = false;

  static defaultProps = {
    margin: '10px 0',
  };

  tooltipSourcesForWord = (word) => {
    if (word.visibleVocabSourcesForUser) {
      return word.visibleVocabSourcesForUser(AppUI.user);
    }
    if (AppUI.user?.showMeanings && AppUI.user?.showVocabMeanings !== false && isPresent(word.meaningSourcePreviews)) {
      return word.meaningSourcePreviews;
    }
    return word.enTranslationSources?.slice(0, 2) || [];
  }

  onClickWord = (event, word) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
      return;
    }
    event.preventDefault();
    this.props.onClickWord(word);
  }

  render() {
    if (this.props.rows) {
      return (
        <RelatedRows isMobile={AppUI.layout.isMobile}>
          {this.props.words.map(word => (
            <VocabListWord
              key={word.id}
              relatedWord
              inDeck={this.props.inDeck}
              showSource={!AppUI.layout.isMobile}
              sources={this.tooltipSourcesForWord(word)}
              word={word}
              user={AppUI.user}
              isMobile={AppUI.layout.isMobile}
              setWord={this.props.onClickWord}
            />
          ))}
        </RelatedRows>
      );
    }
    return (
      <Wrapper margin={this.props.margin}>
        {
          this.props.title &&
          <Text bold margin='0 3px 0 0'>{this.props.title}: </Text>
        }
        {
          this.props.words.map((item, index) => {
            if (this.props.expanded || index < 5 || this.seeMore) {
              return (
                <RelatedWordLink
                  onClick={event => this.onClickWord(event, item)}
                  to={{name: 'vocab.word', params: {wordId: item.id}}}
                  key={item.id}
                  data-tip
                  data-for={item.id}
                >
                  <LinkedWord>
                    {item.targetTextWithDefiniteArticle}
                  </LinkedWord>
                  {
                    isPresent(item.level) && isPresent(this.tooltipSourcesForWord(item)) &&
                      <ReactTooltip
                        place='top'
                        type='dark'
                        effect='solid'
                        id={item.id}
                        class='custom-tooltip'
                      >
                        <div style={{display: 'flex', alignItems: 'center', gap: '8px', maxWidth: '200px'}}>
                          {
                            !this.props.hideLevels && item.level?.position > this.props.referenceWord?.level?.position &&
                            <LevelTag level={item.level}/>
                          }
                          <span>{this.tooltipSourcesForWord(item).map(ts => ts.source?.textForUser ? ts.source.textForUser(AppUI.user) : ts.source?.text).join(', ')}</span>
                        </div>
                      </ReactTooltip>
                  }
                  {
                    (this.props.expanded || index !== 4 || this.seeMore) &&
                      <Text margin='0 4px 0 0'>{index + 1 < this.props.words.length ? ', ' : ''}</Text>
                  }
                </RelatedWordLink>
              );
            }
            return null;
          })
        }
        {
          !this.props.expanded && this.props.words.length > 5 &&
          <>
            {!this.seeMore && <span>...</span> }
            <SeeMore onClick={() => this.seeMore = !this.seeMore}>{this.seeMore ? 'See Less' : 'See More'}</SeeMore>
          </>
        }
      </Wrapper>
    );
  }
}

export default RelatedWords;
